import {ChangeDetectionStrategy, Component, Injectable, input, Signal} from "@angular/core";
import {KommentarModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {Observable, switchMap} from "rxjs";
import {takeUntilDestroyed, toObservable, toSignal} from "@angular/core/rxjs-interop";
import {KommentarTraadKomponent} from "../kommentar-traad/kommentar-traad";
import {Forelder, KommentarDatatjeneste} from "felles-ng2/tjenester/datalager/KommentarDatatjeneste";

const debug = initDebugger('KommentarTraaderKomponent');

@Component({
    selector: 'kommentar-traader',
    templateUrl: 'kommentar-traader.html',
    styleUrl: 'kommentar-traader.scss',
    host: { 'class': 'e2e-kommentartråder' },
    imports: [
        KommentarTraadKomponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class KommentarTraaderKomponent {

    forelder = input.required<Forelder>();

    kommentarer: Signal<KommentarModell[]>;

    constructor(private avhengigheter: KommentarTraaderKomponentAvhengigheter) {
        //kan ikke bruker computed da vi gjør asynk kall
        this.kommentarer = toSignal(toObservable(this.forelder)
          .pipe(
            switchMap(forelder => this.avhengigheter.kommentarer(forelder)),
            takeUntilDestroyed()
          ), {initialValue: []});
    }
}

@Injectable()
export class KommentarTraaderKomponentAvhengigheter {

    constructor(private kommentarDatatjeneste: KommentarDatatjeneste) {
    }

    kommentarer(forelder: Forelder): Observable<KommentarModell[]> {
        return this.kommentarDatatjeneste.finnTilknyttetFraLokallager(forelder);
    }
}
